import React from 'react';
import { Button, Col, ConfigProvider, Form, Input, Modal, Row, Select, Typography } from 'antd';
import locale from "antd/es/locale/es_ES";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import { PostGrup } from "../../../dao/abp/PostGrup";

interface Props {
    element: object;
    visible: boolean;
    id_projecte: string;
    onClose: (value: boolean) => void;
    editar?: boolean;
    alumnes: [];
    selectedIds: [];
}

const GrupModal: React.FC<Props> = (props: Props) => {
    const [form] = Form.useForm();
    const [filtreAula, setFiltreAula] = React.useState<number | null>(null);
    const { Title, Text } = Typography;

    // Get unique classrooms from alumnes list
    const aulesMap = new Map();
    props.alumnes?.forEach((a: any) => {
        if (a.id_aula !== undefined && a.id_aula !== null && !aulesMap.has(a.id_aula)) {
            aulesMap.set(a.id_aula, a.aula_nom);
        }
    });
    const aulesOptions = Array.from(aulesMap.entries()).map(([id, nom]) => ({ value: id, label: nom }));

    const filteredAlumnes = React.useMemo(() => {
        if (!filtreAula) return props.alumnes;
        return props.alumnes.filter((a: any) => String(a.id_aula) === String(filtreAula));
    }, [props.alumnes, filtreAula]);

    async function handleSubmit() {
        try {
            const formData = await form.validateFields();
            // Map labels back to simple IDs if needed, but PostGrup probably expects list of IDs
            // The Select with mode="multiple" returns values (ids)
            console.log("Form Data:", formData);

            await PostGrup(formData, props.id_projecte)

            props.onClose(true);
        } catch (error) {
            console.error("Validation Failed:", error);
        }
    }

    const handleCancel = () => {
        props.onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title={<Title level={4} style={{ margin: 0 }}>Editar Grup</Title>}
                open={props.visible}
                onCancel={handleCancel}
                onOk={handleSubmit}
                width={700}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel·lar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleSubmit}
                        style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                    >
                        Guardar
                    </Button>,
                ]}
            >
                <Form
                    form={form}
                    initialValues={props.element}
                    onFinish={handleSubmit}
                    layout="vertical"
                    style={{ marginTop: 24 }}
                >
                    <Form.Item label="ID" name="id" hidden>
                        <Input />
                    </Form.Item>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Codi del Grup" name="codi"
                                rules={[{ required: true, message: 'El codi és obligatori' }]}>
                                <Input placeholder="Nom o codi del grup" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Tutor" name="tutor">
                                <Input placeholder="Nom del tutor (opcional)" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item label="Enllaç GitLab" name="gitlab">
                        <Input addonBefore="URL" placeholder="https://gitlab.com/..." />
                    </Form.Item>

                    <div style={{ padding: '16px', background: '#f5f5f5', borderRadius: 8, marginBottom: 24 }}>
                        <Text strong style={{ display: 'block', marginBottom: 8 }}>Filtre d'Alumnes</Text>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Select
                                    allowClear
                                    placeholder="Filtrar per aula"
                                    style={{ width: '100%' }}
                                    onChange={(val) => setFiltreAula(val)}
                                    options={aulesOptions}
                                />
                            </Col>
                        </Row>
                    </div>

                    <Form.Item label="Alumnes Assignats" name="alumnes">
                        <Select
                            mode="multiple"
                            optionFilterProp="label"
                            showSearch
                            allowClear
                            style={{ width: '100%' }}
                            placeholder="Selecciona els alumnes (pots buscar per nom)"
                            options={filteredAlumnes}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default GrupModal;
